/**
 * Shared delivery-confidence derivation — the single frontend definition.
 *
 * Delivery confidence is a linear re-projection of the risk score onto a
 * percentage: (5 - score) / 4 * 100, so score 1.0 -> 100% and 5.0 -> 0%.
 * It carries no information beyond the risk score itself; treat it as a
 * presentation of risk, not an independent measurement.
 *
 * Unscored rule (keep identical to lib/riskBand.ts): null, undefined, and
 * the 0 sentinel all mean "not yet evaluated" and return null. Rendering a
 * number for an unscored project fabricates a claim — the old per-page
 * copies returned 0 for null (an unscored project showed "0% / LOW / red")
 * and, worse, 125% for the 0 sentinel since only the bottom was clamped.
 * Callers must render null as an em dash / neutral state.
 */
export function confidenceFromScore(score: number | null | undefined): number | null {
  if (score === null || score === undefined || score === 0) return null;
  const clamped = Math.min(5, Math.max(1, score));
  return Math.round(((5 - clamped) / 4) * 100);
}
